import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaShareAlt,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SocialMediaVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Social Media Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Go Viral with Your Brand</Subheading>}
        heading={
          <Heading>
            Social Media <span tw="text-primary-500">Video Production</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in social media video production in
            **Bur Dubai**, crafting short, engaging, and shareable videos that
            boost your brand’s presence across platforms like Instagram, TikTok,
            and YouTube.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1574717024453-e515679aff46?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media video production setup
          "https://images.unsplash.com/photo-1598550476439-6847785fcea6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Content creator filming
          "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media creative setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Boost Your Socials Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Engaging Social Media Videos"
        description="We create videos that thrive on social platforms."
        cards={[
          {
            icon: <FaShareAlt color="#ff5464" size={40} />,
            title: "Shareable Content",
            description: "Videos designed to go viral and spark engagement.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "High-Quality Shorts",
            description: "Crisp visuals optimized for social media.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Rapid Production",
            description: "Quick delivery to keep up with trends.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform-Specific",
            description: "Tailored for Instagram, TikTok, YouTube, and more.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Brands",
            description: "Bur Dubai’s go-to for social media videos.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Trend-Driven",
            description: "Videos that align with the latest social trends.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Social Media Video Process"
        description={
          <Description>
            We craft viral-ready social media videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Define your brand’s social media goals.</li>
              <li>Concepting: Create trendy, platform-specific ideas.</li>
              <li>Filming: Capture vibrant visuals with mobile-first focus.</li>
              <li>Editing: Enhance with captions, effects, and music.</li>
              <li>Delivery: Provide ready-to-post videos.</li>
              <li>Support: Offer tweaks to maximize engagement.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Mobile-first video editing
          "https://images.unsplash.com/photo-1551817958-d9d86fb29431?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional social media setup
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Creative team meeting
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Social Media Wins in Bur Dubai"
        description="Our social media videos have amplified brands."
        cards={[
          {
            icon: <FaShareAlt color="#ff5464" size={40} />,
            title: "Viral Reach",
            description: "Increased followers with engaging content.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Success",
            description: "90% satisfaction from Bur Dubai brands.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Engagement Boost",
            description: "Drove likes, shares, and comments.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Shine Online?</Subheading>}
        heading="Social Media Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert social media video production
            in Bur Dubai. Get vibrant, shareable videos to grow your online
            presence—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Smartphone with social media apps
          "https://images.unsplash.com/photo-1572048572929-782ede5ee44b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape for social content
          "https://images.unsplash.com/photo-1533422902779-aff35862e462?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media content creation
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
